const flowStages =  {
  AUTHENTICATED: "AUTHENTICATED",
  AUTHENTICATED_FIRST_TIME: "AUTHENTICATED_FIRST_TIME",
  EMAIL_AUTO_LINK: "EMAIL_AUTO_LINK",
  EMAIL_AUTO_LINK_NO_ACTIONS: "EMAIL_AUTO_LINK_NO_ACTIONS",
  CHALLENGE: "CHALLENGE",
  CHALLENGE_MFA_SETUP: "CHALLENGE_MFA_SETUP",
  MFA_SETUP: "MFA_SETUP",
  RESEND_SMS_VERIFICATION_CODE: "RESEND_SMS_VERIFICATION_CODE",
  VERIFY_EMAIL: "VERIFY_EMAIL",
  EMAIL_NOT_VERIFIED: "EMAIL_NOT_VERIFIED",
  RESEND_EMAIL_VERIFICATION_CODE: "RESEND_EMAIL_VERIFICATION_CODE",
  CHANGE_EMAIL_ADDRESS: "CHANGE_EMAIL_ADDRESS",
  SKIP_EMAIL_NOT_VERIFIED: "SKIP_EMAIL_NOT_VERIFIED",
  EXPIRED_NEW_PASSWORD_REQUIRED: "EXPIRED_NEW_PASSWORD_REQUIRED",
  MFA_SETUP_TOTP: "MFA_SETUP_TOTP",
  MFA_SETUP_SMS: "MFA_SETUP_SMS",
  MFA_SETUP_EMAIL: "MFA_SETUP_EMAIL",
  SIGNUP_ALREADY_SIGNED_UP: "SIGNUP_ALREADY_SIGNED_UP",
  SIGNUP_NO_EMAIL: "SIGNUP_NO_EMAIL",
  SIGNUP_SSO_REQUIRED: "SIGNUP_SSO_REQUIRED",
  SIGNUP_VALID: "SIGNUP_VALID",
  SIGNUP_EMAIL_EXISTS: "SIGNUP_EMAIL_EXISTS",
  SIGNUP_PLATFORM_EMAIL_EXISTS: "SIGNUP_PLATFORM_EMAIL_EXISTS",
  SIGNUP_COMPLETE: "SIGNUP_COMPLETE",
  INTERSTITIAL_PAGE: "INTERSTITIAL_PAGE",
}
export default flowStages;